import * as React from 'react';

import {StatsBlockHorizontal} from 'shells/metrics/stats-block-horizontal';
import {Percentage} from 'shells/percentage/percentage';

import type {EngagementStats} from 'nutshell-graphql-types';

import {MessageBounceModal} from '../tooltip-modals/message-bounce-modal';
import {MessageEngagementModal} from '../tooltip-modals/message-engagement-modal';
import {MessageUnsubscribeModal} from '../tooltip-modals/message-unsubscribe-modal';

type Props = {
    isLoading: boolean;
    includeHelp?: boolean;
    stats: EngagementStats | null | undefined;
    includeBounceRate?: boolean;
    onClickStat?: (filterKey: string) => string;
};

export function EngagementStatsBlock(props: Props) {
    const isLoading = props.isLoading;
    const stats = props.stats;
    const shownEngagementStats = [
        {
            key: '1',
            title: 'Messages delivered',
            isLoading: isLoading,
            value: stats ? stats.totalSentCount.toLocaleString() : 0,
            secondaryValue: stats
                ? {
                      value: stats.totalSentCount,
                      nounSingular: 'message',
                      nounPlural: 'messages',
                  }
                : undefined,
            modalComponent: props.includeHelp ? MessageEngagementModal : undefined,
            clickingNavigatesTo: props.onClickStat ? props.onClickStat('sentEditions') : undefined,
        },
        {
            key: '2',
            title: 'Open rate',
            isLoading: isLoading,
            // @ts-expect-error
            value: <Percentage value={stats ? stats.openRate : null} precision={2} />,
            secondaryValue: stats
                ? {
                      value: stats.openCount,
                      nounSingular: 'message opened',
                      nounPlural: 'messages opened',
                  }
                : undefined,
            modalComponent: props.includeHelp ? MessageEngagementModal : undefined,
            clickingNavigatesTo: props.onClickStat
                ? props.onClickStat('viewedEditions')
                : undefined,
        },
        {
            key: '3',
            title: 'Click rate',
            isLoading: isLoading,
            // @ts-expect-error
            value: <Percentage value={stats ? stats.clickRate : null} precision={2} />,
            secondaryValue: stats
                ? {
                      value: stats.clickCount,
                      nounSingular: 'message clicked',
                      nounPlural: 'messages clicked',
                  }
                : undefined,
            modalComponent: props.includeHelp ? MessageEngagementModal : undefined,
            clickingNavigatesTo: props.onClickStat
                ? props.onClickStat('clickedEditions')
                : undefined,
        },
        {
            key: '4',
            title: 'Unsubscribe rate',
            isLoading: isLoading,
            // @ts-expect-error
            value: <Percentage value={stats ? stats.unsubscribeRate : null} precision={2} />,
            secondaryValue: stats
                ? {
                      value: stats.unsubscribeCount,
                      nounSingular: 'unsubscribe',
                      nounPlural: 'unsubscribes',
                  }
                : undefined,
            modalComponent: props.includeHelp ? MessageUnsubscribeModal : undefined,
            clickingNavigatesTo: props.onClickStat
                ? props.onClickStat('unsubscribedEditions')
                : undefined,
        },
    ];

    if (props.includeBounceRate) {
        shownEngagementStats.push({
            key: '5',
            title: 'Bounce rate',
            isLoading: isLoading,
            // @ts-expect-error
            value: <Percentage value={stats ? stats.permanentBounceRate : null} precision={2} />,
            secondaryValue: stats
                ? {
                      value: stats.permanentBounceCount,
                      nounSingular: 'bounce',
                      nounPlural: 'bounces',
                  }
                : undefined,
            modalComponent: props.includeHelp ? MessageBounceModal : undefined,
            clickingNavigatesTo: props.onClickStat
                ? props.onClickStat('bouncedEditions')
                : undefined,
        });
    }

    return (
        <div style={{height: 105}}>
            {/* @ts-expect-error */}
            <StatsBlockHorizontal stats={shownEngagementStats} />
        </div>
    );
}
